import { CONFERENCE_JOINED, CONFERENCE_LEFT } from '../base/conference/actionTypes';
import { SET_CONFIG } from '../base/config/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { SET_CONTROLLER_ENGAGED } from '../remote-control/actionTypes';
import { disableKeyboardShortcuts, disposeKeyboardShortcuts, enableKeyboardShortcuts, initKeyboardShortcuts } from './actions';
MiddlewareRegistry.register((store) => (next) => (action) => {
    const { dispatch } = store;
    switch (action.type) {
        // Keyed on engagement rather than on having permission: a controller who
        // has been granted access but has not yet clicked into the shared screen is
        // still using this app, and should still be able to mute themselves.
        case SET_CONTROLLER_ENGAGED:
            if (action.engaged) {
                dispatch(disableKeyboardShortcuts());
            }
            else {
                dispatch(enableKeyboardShortcuts());
            }
            return next(action);
        case SET_CONFIG: {
            const result = next(action);
            const state = store.getState();
            const { disableShortcuts } = state['features/base/config'];
            if (disableShortcuts !== undefined) {
                if (disableShortcuts) {
                    dispatch(disableKeyboardShortcuts());
                }
                else {
                    dispatch(enableKeyboardShortcuts());
                }
            }
            return result;
        }
        case CONFERENCE_JOINED:
            dispatch(initKeyboardShortcuts());
            break;
        case CONFERENCE_LEFT:
            dispatch(disposeKeyboardShortcuts());
    }
    return next(action);
});
